<div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch space-between; align-items: stretch; flex: 1 1 0%; gap:10px; width: calc(100% - 5px); padding:0 10px;">
  <div class="container">
    <div style="margin:20px"></div>
    <mat-toolbar color="primary" class="toolbar-over-card">
      <div>Total Facts: {{dataSource.filteredData.length}}</div>
      <div style="box-sizing: border-box; display: flex; place-content: flex-end space-between; align-items: flex-end;">
        <button *inRole="roles.EditFeatureSet" mat-icon-button (click)="addFact()">
          <mat-icon matTooltip="Add New Fact">add_circle</mat-icon>
        </button>
        <button mat-icon-button (click)="toggleTimeline()">
          <mat-icon *ngIf="!showTimeline" matTooltip="Show Timeline">timeline</mat-icon>
          <mat-icon *ngIf="showTimeline" matTooltip="Show Grid">table_rows</mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="export()">
            <mat-icon>file_download</mat-icon>
            Export
          </button>
          <button mat-menu-item (click)="exportPivot()">
            <mat-icon>file_download</mat-icon>
            Export Pivot
          </button>
          <button mat-menu-item (click)="fileUpload.click()">
            <mat-icon>file_upload</mat-icon>
            Import
          </button>
        </mat-menu>
        <input type="file" class="file-input" (change)="import($event)" style="display: none" #fileUpload>
      </div>
    </mat-toolbar>

    <mat-card appearance="outlined" class="scrollable-content">
      <mat-card-content *ngIf="dataSource?.data < 1">
        <div
          style="color: #a5addc; display: flex; justify-content: center; align-items: center;  padding: 150px 0; cursor: pointer;"
          (click)="addFact()">
          <div style="display: flex; flex-direction: column; align-items: center; gap: 10px;">
            <mat-icon>emoji_emotions</mat-icon>
            <div style="font-size: 16px;">You don't have any facts yet. Click here to add one!</div>
          </div>
        </div>
      </mat-card-content>
      <mat-card-content *ngIf="dataSource?.data.length > 0">

        <table *ngIf="!showTimeline" mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

          <ng-container matColumnDef="title" class="header-row">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="title"> Fact Title</th>
            <td mat-cell *matCellDef="let fact" (click)="editFact(fact)"
                class="fact-title mat-body" style="cursor: pointer; font-weight: 500"> {{fact.title}} </td>
          </ng-container>

          <ng-container matColumnDef="dateStart">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="dateStart"> Date Start</th>
            <td mat-cell *matCellDef="let fact"> {{fact.dateStart | date: 'mediumDate'}} </td>
          </ng-container>

          <ng-container matColumnDef="dateEnd">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="dateEnd"> Date End</th>
            <td mat-cell *matCellDef="let fact"> {{fact.dateEnd | date: 'mediumDate'}} </td>
          </ng-container>

          <ng-container matColumnDef="contested">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="contested"> Contested</th>
            <td mat-cell *matCellDef="let fact"> {{contested.displayText(fact.contested)}} </td>
          </ng-container>

          <ng-container matColumnDef="material">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="material"> Material</th>
            <td mat-cell *matCellDef="let fact"> {{material.displayText(fact.material)}} </td>
          </ng-container>

          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let fact" (click)="deleteFact(fact.id);">
              <mat-icon matTooltip="Delete" class="deleteIcon" style="cursor: pointer;">delete</mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>

        </table>

        <lex-facts-timeline *ngIf="showTimeline"></lex-facts-timeline>

      </mat-card-content>
      <mat-card-actions style="padding: 0; min-height: unset; height: 20px;">
      </mat-card-actions>
    </mat-card>
    <div style="margin:20px"></div>
  </div>
</div>

